export default __webpack_public_path__ + "static/media/adsform-sec6-bg-big.4b3230a4.png";